import "./style.css"
import "ress"
import { createRoot } from "react-dom/client"
import { datadogLogs } from "@datadog/browser-logs"
import { initM2mComponents } from "m2m-components/initM2mComponents"
import { App } from "./App"

initM2mComponents({
    env: import.meta.env.MODE === "production" ? "production" : "development"
})

const MODE = import.meta.env.MODE

datadogLogs.init({
    service: `m2m-core-manager-front-${MODE}`,
    env: MODE,
    version: import.meta.env.VITE_APP_VERSION,
    clientToken: "puba32e2da77112a2e6b6886d448d294bec",
    site: "datadoghq.com",
    forwardErrorsToLogs: true,
    sampleRate: 100
})
const container = document.getElementById("root")
if (container) {
    const root = createRoot(container)
    root.render(<App />)
}
